import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import Form from "components/Form";
import Modal from "components/Modal";

import { HoveredCard } from "scenes/WorkflowTemplatesLibrary/components/TemplatesList/components/TemplateCard/components";

import useTemplatePublishForm from "./hooks/useTemplatePublishForm";

export function GatedTemplateModal({ process, onSubmit, onClose }) {
  const totalPractices = process?.numAccessList || 0;
  const { formProps, submit, isGated, isPublic, isSubmitting } =
    useTemplatePublishForm(process, onSubmit, onClose);

  const infoStyle = {
    fontSize: "10px",
    color: "#AAA",
    width: "300px",
  };

  return (
    <Modal
      style={{ maxWidth: "600px" }}
      isModalOpen
      onClose={onClose}
      data-test="gated-template-modal"
      size="small"
    >
      <Modal.Header onClose={onClose}>{`Publish ${
        process?.name || "Process"
      }`}</Modal.Header>
      <Modal.Body>
        <Form id="gatedTemplates" onSubmit={submit} {...formProps}>
          <Form.Checkbox
            text="This Workflow Template should be gated"
            name="isGated"
            toggle={false}
            data-test="is-gated-checkbox"
          />
          <div style={infoStyle}>
            If gated, only approved users will be able to access this template.
            If not gated, all Hubly users will be able to access this template.
          </div>
          {isGated && (
            <React.Fragment>
              <div style={{ margin: "20px 0" }}>
                <Form.Checkbox
                  text="This Workflow Template should be visible to all Hubly users"
                  name="isPublic"
                  toggle={false}
                  data-test="is-public-checkbox"
                />
                {isPublic && (
                  <React.Fragment>
                    <div style={infoStyle}>
                      If visible, the template will look like the preview below.
                    </div>
                    <HoveredCard
                      onMouseLeave={() => {}}
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      buttonText="Request Access"
                    >
                      {process?.description}
                    </HoveredCard>
                  </React.Fragment>
                )}
              </div>
            </React.Fragment>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          data-test="publish-template-modal-footer"
        >
          <div
            style={{
              fontSize: "10px",
              color: "#B8B8B8",
              width: "360px",
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <React.Fragment>
              {isGated ? (
                <React.Fragment>
                  <span>{`${
                    totalPractices === 0 ? "No" : totalPractices
                  } practice${
                    totalPractices !== 1 ? "s" : ""
                  } will have access to your workflow templates.`}</span>
                  {isPublic && (
                    <span>All other Hubly users can request access.</span>
                  )}
                </React.Fragment>
              ) : (
                <span>
                  All Hubly users will have access to your workflow templates.
                </span>
              )}
            </React.Fragment>
          </div>

          <div>
            <Button basic content="Cancel" onClick={onClose} />
            <Button
              style={{ marginLeft: "0.75em" }}
              primary
              content="Publish"
              type="submit"
              form="gatedTemplates"
              loading={isSubmitting}
            />
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

GatedTemplateModal.propTypes = {
  process: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default GatedTemplateModal;
